import React, {
    useState, useRef, useEffect
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import JoditEditor from 'jodit-react';
import DefaultLayout from "../../../../components/Layout/PortalTemplate";
import {
    BodyContainer,
    ProgressBar,
    WrapperInput,
    TitleInput,
    InputContainer,
    GeneralButtonLanguage
} from "./News.styles";
import {
    PageTitle,
    LabelSlide
} from "../../../../components/Common/CommonLayout";
import Loading from "../../../../components/Layout/CommonLayoutPart/Loading";
import NewsActions from "../../../../actions/News";
import { ColorName } from "../../../../components/Variables";
import Utils from "../../../../libs/Utils";
import Validation from "../../../../libs/Validation";
import history from "../../../../history";
import Constants from "../../../../constants/Constants";
const Edit = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const editor = useRef(null);
    const editorAl = useRef(null);
    const isLoading = useSelector((state) => state.News.isLoading);
    const newsID = useSelector((state) => state.News.newsID);
    const dataNews = useSelector((state) => state.News.dataNews);
    const [contentEn, setContentEn] = useState('');
    const [contentAl, setContentAl] = useState('');
    const fileInput = useRef(null);
    const fileInputDocument = useRef(null);
    const [formData, setFormData] = useState({
        title: {
            en: "",
            al: ""
        },
        description: {
            en: "",
            al: ""
        }
    });
    const [fileUrl, setFileUrl] = useState("");
    const [fileData, setFileData] = useState("");
    const [fileUrlDocument, setFileUrlDocument] = useState("");
    const [fileDataDocument, setFileDataDocument] = useState("");
    const [language, setLanguage] = useState(Utils.getCurrentLanguage());
    const [isMultipleLanguage, setIsmultipleLanguage] = useState(false);

    useEffect(() => {
        if (!newsID) { history.push("/admin/news"); return; }
        const data = {
        };
        dispatch(NewsActions.getNewsById(data, newsID));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const formatNameFile = (file_attach) => {
        if (file_attach) return file_attach.split("/")[1];
    };

    useEffect(() => {
        if (!_.isEmpty(dataNews)) {
            if (dataNews.is_support_mul_lang) {
                if (i18n.language === Constants.LANGUAGE_CODE.AL) {
                    setLanguage(Constants.LANGUAGE_CODE.AL);
                } else {
                    setLanguage(Constants.LANGUAGE_CODE.EN);
                }
            } else if (dataNews.title_json[i18n.language]) {
                setLanguage(i18n.language);
            } else if (i18n.language === Constants.LANGUAGE_CODE.EN) {
                setLanguage(Constants.LANGUAGE_CODE.AL);
            } else {
                setLanguage(Constants.LANGUAGE_CODE.EN);
            }

            const data = { ...formData };
            data.title.en = dataNews.title_json.en;
            data.title.al = dataNews.title_json.al;
            data.description.en = dataNews.description_json.en;
            data.description.al = dataNews.description_json.al;
            setFileUrl(dataNews.url_img_aws);
            setContentAl(dataNews.content_json.al);
            setContentEn(dataNews.content_json.en);
            setIsmultipleLanguage(dataNews.is_support_mul_lang);
            setFileUrlDocument(formatNameFile(dataNews.file_url));
            setFormData(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataNews]);

    const validateMutilpleLanguage = () => {
        const validationRules = [
            {
                name: `${t("general.Title")} ${t("general.English")}`,
                value: formData.title.en,
                rule: ["required", { min: 10, max: 100 }]
            },
            {
                name: `${t("general.Title")} ${t("general.Albanian")}`,
                value: formData.title.al,
                rule: ["required", { min: 10, max: 100 }]
            },
            {
                name: `${t("general.Description")} ${t("general.English")}`,
                value: formData.description.en,
                rule: ["required", { min: 10, max: 200 }]
            },
            {
                name: `${t("general.Description")} ${t("general.Albanian")}`,
                value: formData.description.al,
                rule: ["required", { min: 10, max: 200 }]
            },
            {
                name: `${t("general.Content")} ${t("general.English")}`,
                value: editor.current.value,
                rule: 'required'
            },
            {
                name: `${t("general.Content")} ${t("general.Albanian")}`,
                value: editorAl.current.value,
                rule: 'required'
            }
        ];
        if (!Validation.formValidation(validationRules)) return;
        return true;
    };

    const validateForLanguage = (lang) => {
        const textEditor = lang === Constants.LANGUAGE_CODE.EN ? editor : editorAl;
        const validationRules = [
            {
                name: t("general.Title"),
                value: formData.title[lang],
                rule: ["required", { min: 10, max: 100 }]
            },
            {
                name: t("general.Description"),
                value: formData.description[lang],
                rule: ["required", { min: 10, max: 200 }]
            },
            {
                name: `${t("general.Content")} ${lang === Constants.LANGUAGE_CODE.EN ? t("general.English") : t("general.Albania")}`,
                value: textEditor.current.value,
                rule: 'required'
            }
        ];
        if (!Validation.formValidation(validationRules)) return;
        return true;
    };

    const paramPostSingleLanguage = (param) => {
        if (language === Constants.LANGUAGE_CODE.EN) {
            param.append('title', JSON.stringify({ en: formData.title.en }));
            param.append('description', JSON.stringify({ en: formData.description.en }));
            param.append('content', JSON.stringify({ en: editor.current.value }));
        } else {
            param.append('title', JSON.stringify({ al: formData.title.al }));
            param.append('description', JSON.stringify({ al: formData.description.al }));
            param.append('content', JSON.stringify({ al: editorAl.current.value }));
        }
    };

    const paramPostMultipleLanguage = (param) => {
        param.append('title', JSON.stringify({ en: formData.title.en, al: formData.title.al }));
        param.append('description', JSON.stringify({ en: formData.description.en, al: formData.description.al }));
        param.append('content', JSON.stringify({ en: editor.current.value, al: editorAl.current.value }));
    };

    const editNews = () => {
        let flag = true;
        if (isMultipleLanguage) {
            flag = validateMutilpleLanguage();
        } else if (!validateForLanguage(language)) return;
        if (flag) {
            const param = new FormData();
            if (isMultipleLanguage) paramPostMultipleLanguage(param);
            if (!isMultipleLanguage) paramPostSingleLanguage(param);
            param.append('is_support_mul_lang', isMultipleLanguage);
            if (fileData !== "") param.append('img', fileData);
            if (fileDataDocument !== "") param.append('file', fileDataDocument);
            if (fileUrlDocument === "") param.append('remove_file', true);
            dispatch(NewsActions.updateNews(param, newsID));
        }
    };

    const handleFileChange = (e) => {
        const url = URL.createObjectURL(e.target.files[0]);
        const file = e.target.files[0];
        setFileData(file);
        setFileUrl(url);
    };

    const handleChange = (value, nameInput) => {
        const data = { ...formData };
        data[nameInput][language] = value;
        setFormData(data);
    };

    const deleteFileAttachment = () => {
        setFileData("");
        setFileUrl("");
        fileInput.current.value = "";
    };

    const handleFileDocumentChange = (e) => {
        const url = URL.createObjectURL(e.target.files[0]);
        const file = e.target.files[0];
        setFileDataDocument(file);
        setFileUrlDocument(url);
    };

    const deleteFileAttachmentDocument = () => {
        setFileDataDocument("");
        setFileUrlDocument("");
        fileInputDocument.current.value = "";
    };

    return (
        <DefaultLayout
            userRole='admin'
            isLoading={false}
            page="news"
            content={(
                <BodyContainer>
                    {isLoading && <Loading />}
                    <PageTitle>
                        {t("news.Edit News")}
                    </PageTitle>
                    <ProgressBar className="mb-2">
                        <WrapperInput>
                            <TitleInput>
                                {t("general.Title")}
                                <div className="language">
                                    <LabelSlide className="switch">
                                        <input type="checkbox" checked={!!isMultipleLanguage} onChange={() => setIsmultipleLanguage(!isMultipleLanguage)} />
                                        <span className="slider round" />
                                    </LabelSlide>
                                    {isMultipleLanguage
                                        && (
                                            <>
                                                <GeneralButtonLanguage
                                                    type="button"
                                                    className={(language === Constants.LANGUAGE_CODE.EN) ? "active" : ""}
                                                    value={t("general.English")}
                                                    onClick={() => setLanguage(Constants.LANGUAGE_CODE.EN)}
                                                />
                                                <GeneralButtonLanguage
                                                    type="button"
                                                    className={(language === Constants.LANGUAGE_CODE.AL) ? "active" : ""}
                                                    value={t("general.Albanian")}
                                                    onClick={() => setLanguage(Constants.LANGUAGE_CODE.AL)}
                                                />
                                            </>
                                        )
                                    }
                                    {!isMultipleLanguage
                                        && (
                                            <>
                                                <GeneralButtonLanguage
                                                    type="button"
                                                    className={(language === Constants.LANGUAGE_CODE.EN) ? "active disable" : "disable disable-unclick"}
                                                    value={t("general.English")}
                                                    onClick={() => setLanguage(Constants.LANGUAGE_CODE.AL)}
                                                    disabled
                                                />
                                                <GeneralButtonLanguage
                                                    type="button"
                                                    className={(language === Constants.LANGUAGE_CODE.AL) ? "active disable" : "disable disable-unclick"}
                                                    value={t("general.Albanian")}
                                                    onClick={() => setLanguage(Constants.LANGUAGE_CODE.AL)}
                                                    disabled
                                                />
                                            </>
                                        )
                                    }

                                </div>
                            </TitleInput>
                            <InputContainer
                                value={formData.title[language] || ""}
                                onChange={(event) => handleChange(event.target.value, "title")}
                            />
                        </WrapperInput>
                        <WrapperInput>
                            <TitleInput>{t("general.Description")}</TitleInput>
                            <InputContainer
                                value={formData.description[language] || ""}
                                onChange={(event) => handleChange(event.target.value, "description")}
                            />
                        </WrapperInput>
                        <WrapperInput className="content">
                            <TitleInput>{t("general.Content")}</TitleInput>
                            <div className={language === Constants.LANGUAGE_CODE.EN ? "" : "hidden-content"}>
                                <JoditEditor
                                    ref={editor}
                                    value={contentEn}
                                />
                            </div>
                            <div className={language === Constants.LANGUAGE_CODE.AL ? "" : "hidden-content"}>
                                <JoditEditor
                                    ref={editorAl}
                                    value={contentAl}
                                />
                            </div>
                        </WrapperInput>
                        <WrapperInput className="container-upload">
                            <input
                                ref={fileInput}
                                id='uploadAvatar'
                                type="file"
                                accept="image/gif,image/jpeg,image/png,.gif,.jpeg,.jpg,.png"
                                onChange={(e) => handleFileChange(e)}
                            />
                            {t("news.Featured Image")}
                            {' '}
                            <i className="fas fa-upload" onClick={() => fileInput.current.click()} />
                            {fileUrl
                                && (
                                    <div className="display-image-file">
                                        <img src={fileUrl} alt='file'/>
                                        <div className="remove" onClick={() => deleteFileAttachment()}>X</div>
                                    </div>
                                )
                            }
                        </WrapperInput>
                        <WrapperInput className="container-upload">
                            <input
                                ref={fileInputDocument}
                                id='uploadAvatar'
                                type="file"
                                accept="*"
                                onChange={(e) => handleFileDocumentChange(e)}
                            />
                            {t("news.Attach File")}
                                :
                            {' '}
                            <i className="fas fa-paperclip" onClick={() => fileInputDocument.current.click()} />
                            {fileUrlDocument
                                && (
                                    <div className="file-attach">
                                        <div>
                                            {fileUrlDocument}
                                        </div>
                                        <div className="remove" onClick={() => deleteFileAttachmentDocument()}>X</div>
                                    </div>
                                )
                            }
                        </WrapperInput>
                        <div className="container-button">
                            <GeneralButtonLanguage
                                type="button"
                                className="for-more"
                                background={ColorName.chathamsBlue}
                                value={t("general.Save")}
                                onClick={() => editNews()}
                            />
                        </div>
                    </ProgressBar>
                </BodyContainer>
            )}
        />
    );
};

Edit.propTypes = {

};

export default Edit;
